var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.75095C0 6.55203 0.0790176 6.36127 0.21967 6.22062C0.360322 6.07997 0.551088 6.00095 0.75 6.00095H18.4395L13.719 1.28195C13.5782 1.14112 13.4991 0.950111 13.4991 0.750947C13.4991 0.551784 13.5782 0.360777 13.719 0.219947C13.8598 0.0791173 14.0508 4.69246e-09 14.25 0C14.4492 -4.69246e-09 14.6402 0.0791173 14.781 0.219947L20.781 6.21995C20.8508 6.28962 20.9063 6.37238 20.9441 6.4635C20.9819 6.55462 21.0013 6.6523 21.0013 6.75095C21.0013 6.8496 20.9819 6.94728 20.9441 7.0384C20.9063 7.12951 20.8508 7.21228 20.781 7.28195L14.781 13.2819C14.6402 13.4228 14.4492 13.5019 14.25 13.5019C14.0508 13.5019 13.8598 13.4228 13.719 13.2819C13.5782 13.1411 13.4991 12.9501 13.4991 12.7509C13.4991 12.5518 13.5782 12.3608 13.719 12.2199L18.4395 7.50095H0.75C0.551088 7.50095 0.360322 7.42193 0.21967 7.28128C0.0790176 7.14063 0 6.94986 0 6.75095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.324d7d4e64001ccf4db1726b1ccc30ce.svg";
export { ForwardRef as ReactComponent };